import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  /*{
    path: '/home',
    title: 'Inicio',
    icon: 'icon icon-home',
    class: '',
    extralink: false,
    perm: 'home',
    submenu: []
  },*/
  /*{
    path: '/home',
    title: 'Módulos',
    //icon: 'icon icon-grid',
    icon: 'fas fa-th-large',
    class: '',
    extralink: false,
    perm: 'home',
    submenu: []
  },*/
  {
    path: '/admins',
    title: 'General',
    icon: 'fas fa-user-cog',
    class: '',
    extralink: false,
    perm: 'ADMIN',
    submenu: []
  },
  {
    path: '/settings',
    title: 'Configuración',
    icon: 'fas fa-cog',
    class: '',
    extralink: false,
    perm: 'sett',
    submenu: []
  }
];
